var Aneox;
(function (Aneox) {
  'use strict';

  var Distributors = (function () {

    var locale;

    var countsRendered;

    var continentIds = ['eur', 'nam', 'sam', 'asia', 'afr'];
    var currentContinentIndex;

    var distributorPageElement;
    var distributorPageList;
    var distributorPageListWrapper;
    var distributorWrapper;

    var dataContinents;  
      
    function Distributors(lang) {

      locale = lang;

      distributorPageElement = $('#distributor');
      distributorPageList = $('#distributor-page-list');
      distributorPageListWrapper = $('#distributor-page-list-wrapper');
      distributorWrapper = $('#distributor-wrapper');

      locale.bind('localeChange', function(locale) {
        /*Aneox.Data.Data.distributors.continents.forEach(function(continent) {
          if (!_.isArray(continent.countries)) {
            continent.countries = [continent.countries];
            return;
          }
          continent.countries.sort(function(c1, c2) {
            var name1 = _.isArray(c1.name) ? _.find(c1.name, { locale: locale }).value : c1.name;
            var name2 = _.isArray(c2.name) ? _.find(c2.name, { locale: locale }).value : c2.name;
            if (name1 > name2) {
              return 1;
            } else if (name1 < name2) {
              return -1;
            } else {
              return 0;
            }
          });
        });

        renderCounts(Aneox.Data.Data.distributors.continents);
        renderLists(Aneox.Data.Data.distributors.continents, locale);*/
      });

    }

    function openPage(continent) {
      $('#page-wrapper').addClass('noscroll');
      currentContinentIndex = continentIds.indexOf(continent.id);
      populatePage(continent, locale.getLocale());
      distributorPageElement.fadeIn();
    }

    Distributors.prototype.closePage = function() {
      distributorPageElement.fadeOut();
      $('#page-wrapper').removeClass('noscroll');
    };

    function renderCounts(continents) {
      if (countsRendered) return;
      countsRendered = true;

      $('#distributors-count-continents').text(continents.length);
      $('.js-distributors-count-countries').text(continents.reduce(function(accumulator, continent) {
        var nbCountries = continent.countries.length;
        return accumulator + nbCountries;
      }, 0));
      $('#distributors-count-distributors').text(continents.reduce(function(accumulator, continent) {
        return accumulator + countDistributors(continent);
      }, 0));
    }

    function countDistributors(node) {
      if (node.distributors) {
        if (_.isArray(node.distributors)) {
          return node.distributors.length;
        } else {
          return 1;
        }
      }

      if (node.countries) {
        return node.countries.reduce(function(accumulator, country) {
          return accumulator + countDistributors(country);
        }, 0);
      }
    }

    function renderLists(continents, locale) {
      var fragment = $(document.createDocumentFragment());
      continents.forEach(function(continent) {
        var name = continent.name;
        if (_.isArray(name)) {
          name = _.find(name, { locale: locale }).value;
        }

        var li = $('<li/>');
        var button = $('<button class="button-expand">' + 
          name +
          ' <span class="coloured">(' + countDistributors(continent) + ')</span>' +
        '</button>').appendTo(li);

        var sublist = $('<ul class="distributors-sublist list-unstyled"></ul>').appendTo(li);

        button.click(function() {
          sublist.slideToggle();
        });

        continent.countries.forEach(function(country) {
          var name = _.isArray(country.name) ?
            _.find(country.name, { locale: locale }).value :
            country.name;
          var subli = $('<li/>');
          var button = $('<button class="button-unstyled">' + name + '</button>')
          .appendTo(subli);
          button.click(function() {
            openPage(continent, country.id);
          });
          sublist.append(subli);
        }, $(''));

        fragment.append(li);
      });
      $('#distributors-list').html(fragment);
    }

    function populatePage(continent, locale, countryId) {
      var name = _.isArray(continent.name) ?
        _.find(continent.name, { locale: locale }).value : continent.name;
      
      $('#distributor-title').text(name);
      $('#distributor-photo').attr('src', continent.img);

      distributorPageList.empty();

      distributorPageList.append(continent.countries.reduce(function(accumulator, country) {
        return accumulator + '<li id="distributor-country-item-' + country.id + '">' +
          '<h3 class="distributor-country">' +
            (_.isArray(country.name) ?
              _.find(country.name, { locale: locale }).value
              : country.name) +
          '</h3>' +
          generateDistributors(country) +
        '</li>';
      }, ''));

      setTimeout(function() {
        distributorPageElement.children('.overlay-inner').scrollTop(0);
      }, 0);
      setTimeout(function() {
        var scrollTop = $('#distributor-country-item-' + countryId).offset().top;
        distributorPageElement.children('.overlay-inner').scrollTop(scrollTop);
      }, 100);
    }

    function generateDistributors(country) {
      if (!_.isArray(country.distributors)) {
        country.distributors = [country.distributors];
      }
      return '<ul class="distributor-page-sublist list-unstyled">' +
      country.distributors.reduce(function(accumulator, distributor) {
        return accumulator + '<li>' + 
          _.reduce(distributor, function(accumulator, value, key) {
            switch(key) {
              case 'name':
                return value != null ? accumulator + value : accumulator;
                break;
             case 'address':
                value = _.replace(value,/<[\/]{0,1}(P|p)[^><]*>/g,"");
                return value != null ? accumulator + '<br>'+ value : accumulator;
                break;        
                    
              case 'tel':
                return value != null ? accumulator + '<br>Tel. <a href="tel:' + value + '">' + value + '</a>' : accumulator;
                break;
             case 'fax':
                return value != null ? accumulator + '<br>Fax. <a href="tel:' + value + '">' + value + '</a>' : accumulator;
                break;
              case 'website':
                return value != null ? accumulator + '<br><a target="_blank" href="http://' + value + '">' + value + '</a>' : accumulator;
                break;
              case 'email':
                return value != null ? accumulator + '<br><a href="mailto:' + value + '">' + value + '</a>' : accumulator;
                break;
              default:
                return accumulator + '<br>' + value;
            }
          }, '') +
        '</li>';
      }, '') + '</ul>';
    }
      
    Distributors.prototype.appendDataList = function(locale){
        var dataCountries = app.dataCountries;
        var tempContinents = _.filter(dataCountries, {parentTid: 0});
        var dataDistributors = app.dataImport;
        var countries = _.filter(dataCountries, function(o){
            if(o.parentTid != 0) return o;
        });
        
        tempContinents.forEach(function(continent){
            
            var name = continent.name;
            delete continent.name;
            
            continent.countries = [];
            continent.name = [];
            continent.name.push({locale: "fr", value: name}, {locale: "en", value: continent.localeEn});
            //continent.name.push({locale: "en", value: continent.localeEn});
            countries.forEach(function(countrie){
                
                if(countrie.parentTid === continent.tid){
                    
                    var countrieName = countrie.name;
                    delete countrie.name
                    
                    countrie.distributors = [];
                    countrie.name = [];
                    
                    countrie.name.push({locale: "fr", value: countrieName}, {locale: "en", value: countrie.localeEn});
                    continent.countries.push(countrie);
                    dataDistributors.forEach(function(distributor){
                        
                        if(distributor.countries == countrie.tid){
                            countrie.distributors.push(distributor);
                        }
                    });
                    
                    if(countrie.distributors.length == 0){
                        _.pull(continent.countries, countrie);
                    }   
                }
            });
        });
        
        dataContinents = tempContinents.filter(function(el){
            if(el.countries.length > 0) return el;
        });

        renderCounts(dataContinents);
        renderLists(dataContinents, locale);
    }

    return Distributors;

  })();

  Aneox.Distributors = Distributors;
})(Aneox || (Aneox = {}));